"use client"

import React from "react"
// swiper
import { Swiper, SwiperSlide } from "swiper/react"

// Import Swiper styles
import "swiper/css"
import "swiper/css/free-mode"
import "swiper/css/pagination"

// import required modules
import { Autoplay, FreeMode, Pagination } from "swiper/modules"


const DATA = [
    {
        icon: "/images/icon-1.png",
        heading: "AI Powered Tweet Generation",
        para_1: "One-Click Bulk Creation: Instantly generate batches of tweets, then approve or reject to train Chinu AI on your brand voice.",
        para_2: "Adaptive Writing Style: Our NLP engine learns from your preferences, ensuring every tweet matches your brand's tone."
    },
    {
        icon: "/images/icon-2.png",
        heading: " Smart Media Integration",
        para_1: "GAN-Based Image Creation: Automatically design eye-catching images that elevate your tweets.",
        para_2: "Image-to-Video Magic: Transform static visuals into dynamic, short video clips for higher engagement."
    },

    {
        icon: "/images/icon-3.png",
        heading: "Intelligent Scheduling & Engagement",
        para_1: "Automated Posting: Schedule your tweets for optimal time zones & peak audience hours—either fully on autopilot or with manual approvals.",
        para_2: "Instant Replies: Chinu AI monitors & responds to mentions around the clock, keeping your community conversations active & on-brand."
    },
    {
        icon: "/images/icon-4.png",
        heading: "Real-Time Insights & Trends",
        para_1: "Industry-Aware Suggestions: Stay ahead of the curve with curated tweet ideas based on the latest news and trending topics in your sector.",
        para_2: "Comprehensive Analytics: Track follower growth, engagement rates, & sentiment to refine your social strategy."
    },

]

const KeyPoint = () => {


    return (
        <div className="xl:mt-30 md:mt-20 mt-10 p-[5vw]">
            <div className="md:mb-20 mb-10  w-full text-center">
                <h1 className="md:text-7xl text-3xl font-bold animate__fadeInLeft animate__animated wow">Key selling points</h1>

            </div>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}
                freeMode={true}
                pagination={{
                    clickable: true,
                }}
                autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    640: {
                        slidesPerView: 1, // Mobile: 1 card
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2, // Tablet: 2 cards
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 3, // Desktop: 3 cards
                        spaceBetween: 20,
                    },
                }}
                modules={[FreeMode, Pagination, Autoplay]}
                className="mySwiper !pb-10"
            >
                {DATA.map((item, index) => (
                    <SwiperSlide key={index} className="h-full">
                        <div className="  md:h-[440px] h-[360px]">
                            <div className="card md:p-9 p-5 rounded-2xl border border-[#F2FF00] flex flex-col items-center justify-center gap-3 text-center">
                                <img src={item.icon} alt="" className="md:w-[8vw] w-[20vw]  mx-auto animate__rubberBand animate__animated wow animate__infinite custom-duration" />
                                <h2 className="font-medium text-lg animate__fadeInUp wow animate__animated">{item.heading}</h2>
                                <p className="text-gray-400 font-light animate__fadeInUp wow animate__animated">{item.para_1}</p>
                                <p className="text-gray-400 font-light animate__fadeInUp wow animate__animated">{item.para_2}</p>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <p className="text-gray-400 font-light text-center mt-10 text-lg animate__fadeInRight animate__animated wow">Chinu AI is more than just a tool; it’s an AI Agent crafted to understand your brand’s voice, adapt to <br /> your audience’s preferences, and evolve with industry trends.</p>
        </div>
    )
}

export default KeyPoint
